export const colorUtil = {
    randomHSL,
    generateFromBaseColor
};

function randomHSL(userId){
    const color = "hsla(" + ~~(40 * userId ^ 50)  + "," +
                    "70%,"+
                    "70%,1)"
    return color;
}

const BASE_COLOR = "#8393F4";

function hexToHsl(hex) {
    const value = parseInt(hex.slice(1), 16);
    const r = (value >> 16 & 255) / 255;
    const g = (value >> 8 & 255) / 255;
    const b = (value & 255) / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const l = (max + min) / 2;
    if (max === min) return [0, 0, l];
    const s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
    let h;
    if (r === max) h = (g - b) / (max - min);
    else if (g === max) h = 2 + (b - r) / (max - min);
    else h = 4 + (r - g) / (max - min);
    h *= 60;
    return [h < 0 ? h + 360 : h, s, l];
}

function hueChannel(t1, t2, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (6 * t < 1) return t1 + (t2 - t1) * 6 * t;
    if (2 * t < 1) return t2;
    if (3 * t < 2) return t1 + (t2 - t1) * (2 / 3 - t) * 6;
    return t1;
}

function hslToHex(h, s, l, alpha = 1) {
    const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const t1 = 2 * l - t2;
    const hue = h / 360;
    const channels = s === 0
        ? [l, l, l]
        : [hueChannel(t1, t2, hue + 1 / 3), hueChannel(t1, t2, hue), hueChannel(t1, t2, hue - 1 / 3)];
    const hex = channels.map(channel => Math.round(channel * 255).toString(16).padStart(2, "0")).join("");
    if (alpha >= 1) return `#${hex}`;
    return `#${hex}${Math.round(alpha * 255).toString(16).padStart(2, "0")}`;
}

const [BASE_HUE, BASE_SATURATION, BASE_LIGHTNESS] = hexToHsl(BASE_COLOR);

function generateFromBaseColor(index, numColors, alpha = 1.0) {
    const hue = (BASE_HUE + index * (360 / numColors)) % 360;
    return hslToHex(hue, BASE_SATURATION, BASE_LIGHTNESS, alpha);
}
